// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__emaLD","noInteraction":"EventWrapper_noInteraction__2ZGsY"};